import { gql } from "@apollo/client";

const IS_LOGGEDIN = gql`
  query IsLoggedIn {
    isLoggedIn @client
  }
`;

export default IS_LOGGEDIN;
